import { z } from 'zod/v4-mini';
import { matchingZodObject } from '../utilities/matchingZodObject.js';
export const ZodTiming = matchingZodObject({
    name: z.string(),
    start: z.number(),
    end: z.optional(z.number()),
    threwException: z.optional(z.boolean()),
});
//# sourceMappingURL=Timing.js.map